<template>
  <div>
    <vs-popup
      title="Güncel Mutabakat"
      button-cancel="border"
      :active.sync="isSidebarActiveLocal"
      @cancel="isSidebarActiveLocal = false"
      @close="isSidebarActiveLocal = false"
      classContent="popup-example"
      fullscreen
    >
      <b-row>
        <vs-card>
          <vs-table stripe :data="cariList">
            <template slot="thead">
              <vs-th sort-key="ADI">Adı</vs-th>
              <vs-th sort-key="GSM">Telefon</vs-th>
              <vs-th sort-key="EMAIL">Mail</vs-th>
              <vs-th>Gönder</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].ADI">
                  {{ data[indextr].ADI }}
                </vs-td>
                <vs-td :data="data[indextr].GSM">
                  {{ data[indextr].GSM }}
                </vs-td>
                <vs-td :data="data[indextr].EMAIL">
                  {{ data[indextr].EMAIL }}
                </vs-td>
                <vs-td>
                  <b-button
                    variant="outline-light"
                    v-on:click="
                      gonderilecekCari = data[indextr];
                      promtBaslik = 'Mesaj Gönder';
                      activePrompt = true;
                    "
                  >
                    <Icon
                      icon="material-symbols:send-to-mobile-outline"
                      width="25"
                      height="25"
                      v-b-tooltip.hover.bottom="'Mesaj Gönder'"
                      color="#1E1E1E"
                    />
                  </b-button>

                  <b-button
                    variant="outline-light"
                    v-on:click="
                      gonderilecekCari = data[indextr];
                      promtBaslik = 'Mail Gönder';
                      activePrompt2 = true;
                    "
                  >
                    <Icon
                      icon="ic:round-schedule-send"
                      width="25"
                      height="25"
                      v-b-tooltip.hover.bottom="'Mail Gönder'"
                      color="#1E1E1E"
                    />
                  </b-button>
                </vs-td>
              </vs-tr>

              <vs-tr> </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </b-row>
      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-popup>
    <vs-prompt
      :title="promtBaslik"
      acceptText="Gönder"
      cancelText="Vazgeç"
      @accept="guncelCariMutabakat"
      :active.sync="activePrompt2"
    >
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <span>Gönderim işlemini tamamla</span>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
    <vs-prompt
      :title="promtBaslik"
      acceptText="Gönder"
      cancelText="Vazgeç"
      @accept="guncelCariMutabakat"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        <b-row style="align-items: center">
          <b-col lg="12">
            <span>Gönderim işlemini tamamla</span>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";

import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Store from "../../../store/store";
import state from "../../../store/state";
export default {
  components: { AgGridVue, Icon },
  data() {
    return {
      manualMail: "",
      guncelAddress: "",
      gonderilecekCari: [],
      activePrompt2: false,
      activePrompt: false,
      localeText: null,

      columnDefs: null,
      rowData: null,
      cariList: [],
      promtBaslik: "",

      defaultColDef: {
        sortable: true,
        resizable: true,
      },
    };
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },

    data: {
      type: {},
      required: true,
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val == true) {
        this.iletisimGetir(this.data.ACTID);
        this.actDetail(this.data);
      }
      //  if (val == true) this.yazdir();
      return val;
    },
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
  methods: {
    guncelCariMutabakat(val) {
      let kontrol = false;
      const vs = this.$vs;

      if (this.promtBaslik == "Mesaj Gönder")
        if (this.gonderilecekCari.GSM == "") {
          this.$vs.notify({
            title: "Teklif Onay",
            text: "Telefon numarası bulunmuyor.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
        } else kontrol = true;
      else {
        if (this.gonderilecekCari.EMAIL == "") {
          vs.notify({
            title: "Teklif Onay",
            text: "Mail adresi bulunmuyor.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
        } else kontrol = true;
      }
      if (kontrol == true) this.guncelMutabakatSave();
    },
    guncelMutabakatSave() {
      const vs = this.$vs;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: vm.data.ACTID,
        ACTNAME: vm.data.ACTNAME,
        isType: vm.promtBaslik == "Mesaj Gönder" ? "" : "Mail",
        Mailadd: vm.gonderilecekCari.EMAIL,
      };
      soap.createClient(url, function (err, client) {
        client.INT_ODEME_HATIRLATMASI_MANUEL(args, function (err, result) {
          if (result.INT_ODEME_HATIRLATMASI_MANUELResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_ODEME_HATIRLATMASI_MANUELResult);
            console.log(vm.veriler);
            if (vm.veriler.response == "Ok") {
              vm.guncelAddress = vm.veriler.jsonData;
              vm.actDetail(vm.data);
              if (vm.promtBaslik == "Mesaj Gönder") vm.wpmesajGonder();
              else
                this.$vs.notify({
                  title: "Mail Ödeme Bildirimi",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
            } else {
            }
          } catch (error) {}

          //  vm.cariHareketlerListesi = vm.veriler;
        });
      });
    },

    wpmesajGonder() {
      if (this.gonderilecekCari.GSM == "") {
        this.$vs.notify({
          title: "Teklif Onay",
          text: "Cari Numarası bulunmuyor.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        try {
          // Mesajı oluştur
          const rawMessage =
            `Denizli Caner Otomotiv San.Tic. A.Ş. Ödeme Hatırlatması. Sayın: ` +
            this.data.ACTNAME +
            ` Bu ileti Caner Group Crm sistemi tarafından Ödeme Hatırlatma sağlamak için otomatik olarak gönderilmiştir. Lütfen Aşağıdaki linke tıklayarak Ödeme Bildirimini onaylayınız.  Saygılarımızla... `;

          // Orijinal URL
          const link = `https://int.kamyonyedekparca.com/odeme-hatirlatmasi/${this.data.ACTID}/${this.guncelAddress}`;
          // Tüm mesaj ve linki birleştirip encode et
          const fullMessage = `${rawMessage} ${link}`;
          const encodedMessage = encodeURIComponent(fullMessage);

          // GSM numarasını düzenle
          const gsm = this.gonderilecekCari.GSM.trim().replace("+", "");

          // WhatsApp linkini oluştur
          const whatsappLink = `https://wa.me/${gsm}?text=${encodedMessage}`;

          // WhatsApp linkini yeni bir sekmede aç
          window.open(whatsappLink, "_blank");
        } catch (error) {}
      }
    },
    iletisimGetir(CariId) {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        CariId: CariId,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY_ILETISIM_LIST(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAY_ILETISIM_LISTResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAY_ILETISIM_LISTResult);

            vm.cariList = JSON.parse(vm.veriler.jsonData);
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    actDetail(item) {
      var vm = this;

      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: item.ACTID,
        isType: "Odeme",
      };
      soap.createClient(url, function (err, client) {
        client.INT_GUNCEL_MUTABAKAT_LIST(args, function (err, result) {
          if (result.INT_GUNCEL_MUTABAKAT_LISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_GUNCEL_MUTABAKAT_LISTResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.rowData = list;
            } else {
              vs.notify({
                title: "Uyarı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Liste getirilirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    },
    currencyFormatter(currency, sign) {
      if (currency == "" || currency == null) {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Dönem",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "YILAY",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Mail",
        field: "EMAIL",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "İşlem Tarihi",
        field: "ISLEMTARIHI",
        sortable: true,
        filter: "agTextColumnFilter",

        valueFormatter: this.parseDate,
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Borç",
        field: "BORC",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.BORC, "₺"),
      },
      {
        headerName: "Alacak",
        field: "ALACAK",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.ALACAK, "₺"),
      },
      {
        headerName: "Bakiye",
        field: "BAKIYE",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.BAKIYE, "₺"),
      },
      {
        headerName: "Gönderi Key",
        field: "GONDKEY",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Durum",
        field: "DURUM",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Red Sebep",
        field: "REDSEBEP",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
    ];
  },
};
</script>
<style lang="scss">
.con-vs-dialog {
  z-index: 52005555;
}
</style>
